module.exports = __webpack_public_path__ + "static/media/amazon-preview-white.d01347c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/amazon-preview-white.png
// module id = 660
// module chunks = 0